module.exports = __webpack_public_path__ + "static/img/presaleIcon.90846cf4.svg";